export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  category: string;
  tags: string[];
  author: string;
  date: string;
  readMinutes: number;
  cover: string;
  content: string[];
}

export const newsCategories: string[] = [
  "全部",
  "赛事战报",
  "球队动态",
  "转会市场",
  "数据分析",
  "赛前前瞻",
];

export const newsList: NewsItem[] = [
  {
    id: "n-001",
    title: "曼城主场 2:1 力克皇家马德里，德布劳内制胜球点燃伊蒂哈德",
    summary:
      "一场焦点大战中，曼城凭借哈兰德和德布劳内的进球主场击败皇马，拿下联赛阶段关键三分。",
    category: "赛事战报",
    tags: ["曼城", "皇家马德里", "联赛阶段"],
    author: "沈亦辰",
    date: "2026-10-15",
    readMinutes: 4,
    cover: "https://readdy.ai/api/search-image?query=Football%20players%20celebrating%20a%20goal%20in%20a%20floodlit%20stadium%2C%20sky%20blue%20kit%2C%20blurred%20crowd%20background%2C%20dramatic%20sports%20photography%2C%20high%20detail&width=1200&height=675&seq=ucl-news-001&orientation=landscape",
    content: [
      "在刚刚结束的欧冠联赛阶段第 8 轮焦点战中，曼城坐镇伊蒂哈德球场以 2:1 击败皇家马德里，延续了本赛季在欧冠赛场的不败势头。",
      "比赛第 18 分钟，德布劳内右路精准传中，哈兰德前点甩头破门为曼城首开纪录。皇马在第 41 分钟由维尼修斯抓住反击机会低射远角扳平比分，双方带着 1:1 的比分进入中场休息。",
      "易边再战，第 61 分钟罗德里中路直塞，德布劳内禁区弧顶推射远角得手，帮助主队再次取得领先。此后皇马连续做出人员调整加强进攻，但曼城的防线在最后阶段保持了高度专注。",
      "全场数据方面，曼城控球率达到 58%，射门次数 13 比 9 领先，传球成功率同样占据优势。赛后主帅在采访中表示，球队在比赛的关键节点展现出了应有的成熟度。",
    ],
  },
  {
    id: "n-002",
    title: "联赛阶段最后一轮前瞻：八张直通 16 强的门票花落谁家",
    summary:
      "联赛阶段收官在即，前八名直接晋级的名额争夺进入白热化，多支球队仍有机会完成反超。",
    category: "赛前前瞻",
    tags: ["联赛阶段", "积分榜"],
    author: "林知远",
    date: "2026-10-14",
    readMinutes: 6,
    cover: "https://readdy.ai/api/search-image?query=Football%20tactical%20whiteboard%20with%20formation%20markers%20and%20a%20stadium%20blurred%20in%20the%20background%2C%20analytical%20sports%20editorial%20style%2C%20clean%20composition&width=1200&height=675&seq=ucl-news-002&orientation=landscape",
    content: [
      "随着联赛阶段进入最后一轮，各队为直通 16 强的名额展开了最后的冲刺。按照现行赛制，积分榜前八名将直接晋级淘汰赛，而第 9 至 24 名则需要通过附加赛争夺剩余席位。",
      "目前排名靠前的几支球队优势并不稳固，一轮比赛的结果就可能导致排名发生明显变化。净胜球、进球数等细节指标很可能成为决定命运的关键。",
      "从赛程难度来看，部分球队需要在最后一轮面对同样需要抢分的对手，比赛的对抗强度预计会进一步升级。",
      "对于球迷而言，最后一轮的同一时间开球安排意味着多个赛场的形势会实时联动，观赛体验将十分刺激。",
    ],
  },
  {
    id: "n-003",
    title: "亚马尔再度刷新纪录，成为欧冠改制后最年轻的连续进球者",
    summary:
      "巴塞罗那小将亚马尔在连续两场欧冠比赛中取得进球，刷新了改制后的最年轻纪录。",
    category: "球队动态",
    tags: ["巴塞罗那", "拉明·亚马尔"],
    author: "周蔓青",
    date: "2026-10-13",
    readMinutes: 3,
    cover: "https://readdy.ai/api/search-image?query=Young%20football%20player%20in%20blue%20and%20red%20kit%20dribbling%20the%20ball%20on%20a%20night%20pitch%2C%20motion%20blur%2C%20dramatic%20lighting%2C%20sports%20photography&width=1200&height=675&seq=ucl-news-003&orientation=landscape",
    content: [
      "巴塞罗那边锋拉明·亚马尔在球队近两场欧冠比赛中连续取得进球，凭借这一表现，他成为了欧冠改制以来最年轻的连续进球球员。",
      "这位年轻球员的成长速度令人瞩目。本赛季他在右路的内切射门和传中质量都有明显提升，已经成为球队进攻端最稳定的输出点之一。",
      "主教练在赛后表示，球队会继续为年轻球员创造合适的成长环境，同时也会合理控制他们的出场时间。",
      "从数据上看，亚马尔的场均关键传球和成功过人次数均位居队内前列，他的表现也被认为是本赛季巴萨进攻端最大的惊喜。",
    ],
  },
  {
    id: "n-004",
    title: "数据解读：高位压迫为何成为本赛季欧冠的主流打法",
    summary:
      "通过跑动距离、抢断位置等数据，我们可以更清楚地看到高位压迫战术在本赛季欧冠的流行。",
    category: "数据分析",
    tags: ["战术分析", "高位压迫"],
    author: "顾长风",
    date: "2026-10-12",
    readMinutes: 7,
    cover: "https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20of%20football%20passing%20network%20and%20heatmap%20on%20a%20dark%20background%20with%20blue%20and%20orange%20accents%2C%20modern%20editorial%20graphic%20style&width=1200&height=675&seq=ucl-news-004&orientation=landscape",
    content: [
      "本赛季欧冠联赛阶段，多支强队不约而同地提高了前场压迫的强度。通过统计各队在对方半场完成的抢断次数，可以明显看到这一趋势。",
      "高位压迫的核心并不只是跑动，而是整体阵型的同步移动与协防意识。当一名球员上前逼抢时，身后的队友需要迅速压缩空间，切断对手的出球线路。",
      "数据同时显示，采取高位压迫的球队在前场夺回球权后，往往能在 10 秒内完成一次射门，这种“就地反击”的效率远高于从后场发起的阵地进攻。",
      "当然，高位压迫也意味着体能的巨大消耗与身后的空当风险。如何在压迫强度与防守稳定性之间找到平衡，将是各队教练组需要持续思考的问题。",
    ],
  },
  {
    id: "n-005",
    title: "拜仁与巴黎互交白卷式对攻，中场博弈成比赛焦点",
    summary: "安联球场的较量中，双方在中场展开高强度对抗，边路攻防转换成为比赛最大看点。",
    category: "赛事战报",
    tags: ["拜仁慕尼黑", "巴黎圣日耳曼"],
    author: "沈亦辰",
    date: "2026-10-15",
    readMinutes: 5,
    cover: "https://readdy.ai/api/search-image?query=Two%20football%20teams%20battling%20for%20the%20ball%20in%20midfield%20under%20bright%20stadium%20lights%2C%20red%20and%20navy%20kits%2C%20dynamic%20action%20sports%20photography&width=1200&height=675&seq=ucl-news-005&orientation=landscape",
    content: [
      "拜仁慕尼黑与巴黎圣日耳曼的对话，是一场典型的高质量中场博弈。两支球队都试图通过中场的控制来掌握比赛主动权。",
      "拜仁依靠凯恩的支点作用完成前场串联，巴黎则借助边路球员的个人能力制造威胁。上半场第 23 分钟与第 44 分钟，双方各入一球，比分上的平衡也反映了场面的胶着。",
      "下半场开场后，双方都没有急于做出调整，而是继续在中场展开拉锯。教练组显然对球队的整体表现基本满意，更愿意通过耐心的传导寻找机会。",
      "整体来看，这场比赛充分展现了两支球队在战术执行层面的成熟度，也为后续的淘汰赛较量埋下了伏笔。",
    ],
  },
  {
    id: "n-006",
    title: "转会观察：多家豪门关注新星中场，冬窗或现大手笔",
    summary: "随着赛季深入，多名年轻中场成为转会市场的热门目标，冬窗动向值得关注。",
    category: "转会市场",
    tags: ["转会", "中场"],
    author: "林知远",
    date: "2026-10-11",
    readMinutes: 4,
    cover: "https://readdy.ai/api/search-image?query=Empty%20modern%20football%20stadium%20seats%20with%20soft%20daylight%20and%20blue%20tones%2C%20calm%20editorial%20sports%20photography%2C%20minimal%20composition&width=1200&height=675&seq=ucl-news-006&orientation=landscape",
    content: [
      "随着赛季推进，多家欧洲豪门开始为冬季转会窗口做准备，其中中场位置的补强成为重点方向。",
      "一些在欧冠赛场表现亮眼的年轻球员，凭借稳定的出场时间和可靠的比赛数据，吸引了球探的持续关注。",
      "不过受制于财政公平政策与球队阵容结构，真正在冬窗完成重磅交易并不容易，更多球队倾向于提前锁定协议，为夏窗做准备。",
      "对于球迷来说，接下来几个月关于转会传闻的消息会明显增多，建议以俱乐部官方公告为准。",
    ],
  },
  {
    id: "n-007",
    title: "国米 2:2 战平巴萨，巴雷拉补时绝平引爆梅阿查",
    summary: "国际米兰在补时阶段由巴雷拉远射扳平比分，与巴塞罗那 2:2 握手言和。",
    category: "赛事战报",
    tags: ["国际米兰", "巴塞罗那"],
    author: "周蔓青",
    date: "2026-10-08",
    readMinutes: 4,
    cover: "https://readdy.ai/api/search-image?query=Football%20player%20striking%20the%20ball%20from%20distance%20with%20stadium%20lights%20and%20blue%20black%20fans%20in%20background%2C%20dramatic%20sports%20photography&width=1200&height=675&seq=ucl-news-007&orientation=landscape",
    content: [
      "梅阿查球场见证了一场跌宕起伏的进球大战，国际米兰在补时阶段由巴雷拉远射破门，最终 2:2 战平巴塞罗那。",
      "比赛中国米两度领先又两度被追平，劳塔罗·马丁内斯延续了良好的进球感觉，而巴萨则依靠莱万多夫斯基与亚马尔的进球完成反超。",
      "第 88 分钟，巴雷拉在禁区外围的远射经过折射入网，帮助主队艰难地拿到一分。全场球迷的欢呼声几乎掀翻球场顶棚。",
      "从数据上看，巴萨在控球率和射门次数上略占优势，但国米在关键区域的处理同样高效，平局的结果基本反映了比赛的实际情况。",
    ],
  },
  {
    id: "n-008",
    title: "阿森纳客场 3:1 击败曼联，萨卡与厄德高联袂建功",
    summary: "阿森纳凭借高效反击客场取胜，萨卡、赖斯和厄德高各入一球。",
    category: "赛事战报",
    tags: ["阿森纳", "曼联"],
    author: "顾长风",
    date: "2026-10-08",
    readMinutes: 4,
    cover: "https://readdy.ai/api/search-image?query=Football%20player%20celebrating%20in%20a%20red%20and%20white%20kit%20in%20front%20of%20a%20packed%20stadium%20crowd%20at%20night%2C%20dynamic%20sports%20photography&width=1200&height=675&seq=ucl-news-008&orientation=landscape",
    content: [
      "老特拉福德球场的英超内战中，阿森纳凭借出色的反击效率以 3:1 击败曼联，拿下一场含金量十足的客场胜利。",
      "上半场萨卡接到厄德高的直塞后单刀破门，随后曼联由布鲁诺·费尔南德斯任意球扳平。下半场赖斯在角球混战中补射入网，厄德高则在终场前推射锁定胜局。",
      "整场比赛阿森纳的传球成功率与射正次数都明显领先，球队在攻防转换中的执行力成为取胜关键。",
      "赛后曼联主帅承认球队在防守端的专注度需要提升，尤其是在定位球的防守组织上仍有改进空间。",
    ],
  },
];